import * as Sentry from '@sentry/react';
import type { AxiosError } from 'axios';

Sentry.init({
  dsn: 'https://7eb0e4dfba65f849c7bafc3197f29010@o1181643.ingest.us.sentry.io/4506937804455936',
  environment: import.meta.env.MODE,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost'],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  beforeSend(event, hint) {
    const error = hint?.originalException as AxiosError | undefined;

    if (error?.isAxiosError) {
      const status = error.response?.status;

      // Ignore 401 and 404
      if (status === 401 || status === 404) {
        return null; // prevents sending to Sentry
      }
    }

    return event;
  },
});
